<template>
  <div class="kb-main">
    <div class="left-container">
      <div class="title">Knowledge Base</div>
      <div class="kb-list">
        <div class="folder" v-for="(f, i) in folders" :key="i">
          <div class="folder-container" @click="f['show'] = !f['show']">
            <div>{{ f['folder'] }}</div>
            <img
              src="https://dsmlib.logistics.systems/Files/Icons/icons8-expand-arrow-24.png"
              :style="{ transform: `scaleY(${f['show'] ? -1 : 1})` }"
            />
          </div>
          <div
            class="kb-name"
            @click="getContent(fi)"
            v-for="(fi, ii) in f['files']"
            :key="ii"
            :title="fi['name'].split('.html')[0]"
            :style="{
              marginLeft: '20px',
              display: f['show'] ? '' : 'none',
              fontWeight: `${fi['directory']}_${fi['name']}` == openedKB ? 'bold' : 'normal',
            }"
          >
            {{ fi['name'].split('.html')[0] }}
          </div>
        </div>
      </div>
    </div>
    <div class="right-container" v-html="htmlContent" @click="handleContentClick"></div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  components: {},
  data: function () {
    return {
      folders: [],
      htmlContent: '',

      openedKB: '',
    };
  },
  props: {},
  methods: {
    getContent: async function (item) {
      this.openedKB = `${item['directory']}_${item['name']}`;
      this.htmlContent = (
        await Axios.get(`/KnowledgeBase/GetContent?folder=${item['directory']}&file=${item['name']}`)
      ).data;

      const searchVal = this.$route.query['search'];
      if (searchVal) {
        const searchLength = searchVal.length;
        const reg = new RegExp(searchVal, 'gi');

        const index = [];
        let match = null;
        while ((match = reg.exec(this.htmlContent)) !== null) {
          index.push(match.index);
        }

        index.forEach((i, ii) => {
          const start = i + (ii * 13);
          const end = start + searchLength;
          this.htmlContent = [
            this.htmlContent.slice(0, start),
            '<mark>',
            this.htmlContent.substring(start, end),
            '</mark>',
            this.htmlContent.slice(end),
          ].join('');
        });
      }
    },
    handleContentClick: function(event) {
      const link = event.target.closest('a[data-doc]');
      if (!link) {
        return;
      }
      event.preventDefault();
      const docLinkData = link.getAttribute('data-doc');
      if (docLinkData) {
        const [directory, name] = docLinkData.split('/');
        this.getContent({ directory: directory, length: 0, name: `${name}.html` });
      }
    },
  },
  async mounted() {
    this.folders = [];
    const allFiles = (await Axios.get('/KnowledgeBase/GetFiles')).data;
    if (!allFiles) {
      this.folders = [];
    }

    const folder = [...new Set(allFiles.map((f) => f['directory']))];
    const folderArr = folder.map((m) => {
      return {
        seq: m.split('.')[0],
        name: m,
      };
    }); //splitting the number out and put into sequence

    folderArr.sort((a, b) => a.seq - b.seq); //sort by the sequence key
    const folderTemp = [...new Set(folderArr.map((f) => f['name']))]; //new array with the folder name with numbering

    folderTemp.forEach((f) => {
      this.folders.push({
        folder: f,
        files: allFiles.filter((af) => af['directory'] == f),
        show: false,
      });
    });

    const query = this.$route.query;
    if (query['dir'] && query['file']) {
      const folderToOpen = this.folders.find((f) => f['folder'] == query['dir']);
      if (folderToOpen) {
        folderToOpen['show'] = true;
        const fileToOpen = folderToOpen['files'].find((f) => f['name'].split('.')[0] == query['file']);
        if (fileToOpen) {
          this.getContent(fileToOpen);
        }
      }
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.kb-main {
  padding: 10px 45px;
  display: flex;
  font-size: 12px;

  > .left-container,
  > .right-container {
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    width: 100%;
  }

  > .right-container {
    overflow: auto;
  }

  > .left-container {
    max-width: 250px;
    min-width: 250px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;

    > .title {
      font-weight: bold;
      font-size: 1.2em;
      text-align: center;
      margin-bottom: 10px;
    }

    > .kb-list {
      overflow: auto;
      height: 100%;

      > .folder {
        border: 1px solid gray;
        border-radius: 5px;
        padding: 5px;
        margin-bottom: 5px;
        width: 100%;

        > .folder-container {
          display: flex;
          align-items: center;
          cursor: pointer;

          &:hover {
            font-weight: bold;
          }

          > :nth-child(1) {
            width: 100%;
          }

          > :nth-child(2) {
            transition: 0.3s;
          }
        }

        > .kb-name {
          cursor: pointer;

          &:hover {
            font-weight: bold !important;
          }
        }
      }
    }
  }
}
</style>
